var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMatchedReplies01 = function SvgMatchedReplies01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "matched_replies-01_svg2__a",
    x1: 54.96,
    x2: 232.85,
    y1: 209.32,
    y2: 70.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#matched_replies-01_svg2__a",
    id: "matched_replies-01_svg2__b",
    x1: 34.68,
    x2: 212.57,
    y1: 183.35,
    y2: 44.43
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#matched_replies-01_svg2__a",
    id: "matched_replies-01_svg2__c",
    x1: -10.67,
    x2: 167.21,
    y1: 125.27,
    y2: -13.65
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#matched_replies-01_svg2__a",
    id: "matched_replies-01_svg2__d",
    x1: 44.82,
    x2: 222.71,
    y1: 196.33,
    y2: 57.42
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#matched_replies-01_svg2__a",
    id: "matched_replies-01_svg2__e",
    x1: -6.38,
    x2: 171.5,
    y1: 130.76,
    y2: -8.15
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#matched_replies-01_svg2__a",
    id: "matched_replies-01_svg2__f",
    x1: 53.28,
    x2: 231.16,
    y1: 207.16,
    y2: 68.25
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#matched_replies-01_svg2__a",
    id: "matched_replies-01_svg2__g",
    x1: 2.37,
    x2: 180.26,
    y1: 141.98,
    y2: 3.06
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#matched_replies-01_svg2__a",
    id: "matched_replies-01_svg2__h",
    x1: -14.53,
    x2: 163.35,
    y1: 120.33,
    y2: -18.59
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#matched_replies-01_svg2__a",
    id: "matched_replies-01_svg2__i",
    x1: 10.74,
    x2: 188.63,
    y1: 152.69,
    y2: 13.78
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#matched_replies-01_svg2__a",
    id: "matched_replies-01_svg2__j",
    x1: 12.81,
    x2: 190.7,
    y1: 155.35,
    y2: 16.43
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M109.85 148.14h55.16c1.78 0 3.23-1.45 3.23-3.23s-1.45-3.23-3.23-3.23h-55.16c-1.78 0-3.23 1.45-3.23 3.23s1.45 3.23 3.23 3.23",
    style: {
      fill: "url(#matched_replies-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.85 106.34h55.16c1.78 0 3.23-1.45 3.23-3.23s-1.45-3.23-3.23-3.23h-55.16c-1.78 0-3.23 1.45-3.23 3.23s1.45 3.23 3.23 3.23",
    style: {
      fill: "url(#matched_replies-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.47 129.01H53.93c-.88 0-1.72.36-2.33.99l-20.53 21.38v-19.14c0-1.78-1.44-3.23-3.23-3.23H16.56c-5.57 0-10.11-4.52-10.11-10.09v-66.8c0-5.57 4.54-10.11 10.11-10.11h84.04c1.78 0 3.23-1.45 3.23-3.23s-1.45-3.23-3.23-3.23H16.56C7.44 35.56 0 43 0 52.12v66.8c0 9.12 7.44 16.54 16.56 16.54h8.05v23.93c0 1.32.8 2.5 2.02 2.99s2.62.19 3.53-.76l25.13-26.16h13.17c1.78 0 3.23-1.45 3.23-3.23S70.24 129 68.46 129Z",
    style: {
      fill: "url(#matched_replies-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.85 127.24h55.16c1.78 0 3.23-1.45 3.23-3.23s-1.45-3.23-3.23-3.23h-55.16c-1.78 0-3.23 1.45-3.23 3.23s1.45 3.23 3.23 3.23",
    style: {
      fill: "url(#matched_replies-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.51 85.76c0-1.78-1.45-3.23-3.23-3.23H29.21c-1.78 0-3.23 1.45-3.23 3.23s1.45 3.23 3.23 3.23h44.07c1.78 0 3.23-1.45 3.23-3.23",
    style: {
      fill: "url(#matched_replies-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.48 160.46c7.25-10.21 11.52-22.69 11.52-36.18 0-11.15-2.92-21.61-8.02-30.67a3.23 3.23 0 0 0-4.39-1.23c-1.55.87-2.1 2.84-1.23 4.39 4.58 8.13 7.19 17.51 7.19 27.51 0 12.61-4.15 24.23-11.17 33.59-.59.79-.79 1.81-.53 2.77l6.74 25.18-31.38-8.4c-.61-.16-1.25-.14-1.85.06a56.5 56.5 0 0 1-17.92 2.92c-28.44 0-51.94-21.15-55.61-48.58-.33-2.46-.5-4.97-.5-7.53 0-18.68 9.13-35.22 23.16-45.42a3.23 3.23 0 0 0-3.8-5.22c-15.65 11.37-25.82 29.82-25.82 50.64 0 2.84.19 5.64.56 8.39 4.1 30.59 30.3 54.18 62.01 54.18 6.64 0 13.02-1.05 19.03-2.95l35.85 9.6c1.11.3 2.3-.02 3.12-.84.81-.81 1.13-2 .83-3.12l-7.79-29.08Z",
    style: {
      fill: "url(#matched_replies-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.37 110.13c1.78 0 3.23-1.45 3.23-3.23s-1.45-3.23-3.23-3.23H29.21c-1.78 0-3.23 1.45-3.23 3.23s1.45 3.23 3.23 3.23h36.15Z",
    style: {
      fill: "url(#matched_replies-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.21 61.37c-1.78 0-3.23 1.45-3.23 3.23s1.45 3.23 3.23 3.23h55.24c1.78 0 3.23-1.45 3.23-3.23s-1.45-3.23-3.23-3.23z",
    style: {
      fill: "url(#matched_replies-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.88 44.53c-1.75-1.75-4.38-1.75-6.14 0-1.75 1.75-1.75 4.38 0 6.14l11.84 11.84c.88.88 1.75 1.32 3.07 1.32s2.19-.44 3.07-1.32l22.8-22.8c1.75-1.75 1.75-4.38 0-6.14-1.75-1.75-4.38-1.75-6.14 0L143.65 53.3z",
    style: {
      fill: "url(#matched_replies-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.22 89.68c22.8 0 41.65-18.85 41.65-41.65 0-14.47-7.45-27.62-19.73-35.51-2.19-1.32-4.82-.44-6.14 1.32-1.32 2.19-.44 4.82 1.31 6.14 9.64 6.14 15.34 16.66 15.34 28.06 0 17.97-14.9 32.88-32.88 32.88s-32.44-14.91-32.44-32.88 14.91-32.88 32.88-32.88c2.63 0 4.38-1.75 4.38-4.38s-1.75-4.38-4.38-4.38c-22.8 0-41.65 18.85-41.65 41.65s18.85 41.65 41.65 41.65Z",
    style: {
      fill: "url(#matched_replies-01_svg2__j)"
    }
  }));
};
export default SvgMatchedReplies01;